<template>
  <div class="container">
    <TopHeader title="免密签约"></TopHeader>

    <!-- 免密签约绑定 -->
    <div v-if="!isAuth" class="content">
      <van-form
        ref="formRef"
        v-model="form"
        label-width="64"
        :show-error="false"
        :show-error-message="true"
        :disabled="isSign"
      >
        <van-field v-model.trim="form.dptName" disabled class="field">
          <template v-slot:label>
            <div class="label">签约商户</div>
          </template>
        </van-field>

        <van-field v-model.trim="form.userName" disabled class="field">
          <template v-slot:label>
            <div class="label">签约用户</div>
          </template>
        </van-field>
        <van-field
          v-model.trim="form.cardNo"
          name="cardNo"
          placeholder="请输入银行卡号"
          :rules="bankCardRules"
          class="field"
        >
          <template v-slot:label>
            <div class="label">银行卡号</div>
          </template>
        </van-field>
        <van-field
          v-model.trim="form.phone"
          name="phone"
          placeholder="请输入手机号"
          :rules="phoneRules"
          class="field"
        >
          <template v-slot:label>
            <div class="label">手机号</div>
          </template>
        </van-field>
        <van-field
          v-if="!isSign"
          v-model.trim="form.code"
          name="code"
          placeholder="请输入验证码"
          :rules="codeRules"
          class="field"
        >
          <template v-slot:label>
            <div class="label">验证码</div>
          </template>
          <template v-if="!isSign" #extra>
            <div
              class="message"
              :class="{ disabled: countdown > 0 }"
              @click="getVerificationCode"
            >
              {{ countdownText }}
            </div>
          </template>
        </van-field>
        <van-field v-if="isSign" class="field">
          <template v-slot:label>
            <div class="label">状态</div>
          </template>
          <template #extra>
            <div class="status">已签约</div>
          </template>
        </van-field>
      </van-form>
    </div>
    <div style="display: flex; justify-content: center">
      <van-button
        v-if="!isAuth"
        class="button"
        type="primary"
        native-type="button"
        @click="onSubmit"
      >
        {{ isSign ? '解约' : '验证信息' }}
      </van-button>
    </div>
    <div v-if="!isAuth && !isSign" class="tips">
      1、请确认免密签约商户是否正确。
      <br />
      2、支持工行一类卡、电子钱包二类卡、电子钱包三类卡等开通免密支付。
      <br />
      3、本次签约仅用于此商户的食堂充值，无其它用途，单次免密充值金额最大为200。
    </div>
    <!-- 免密授权 -->
    <div v-if="isAuth" class="content">
      <!-- 遮罩层 -->
      <div class="mask"></div>
      <van-form
        ref="formRef"
        v-model="form"
        label-width="64"
        :disabled="isAuth"
      >
        <van-field v-model.trim="form.dptName" name="cardNo" class="field">
          <template v-slot:label>
            <div class="label">签约商户</div>
          </template>
        </van-field>

        <van-field v-model.trim="form.cardNo" name="cardNo" class="field">
          <template v-slot:label>
            <div class="label">银行卡号</div>
          </template>
        </van-field>
        <van-field
          v-model.trim="form.phone"
          name="phone"
          placeholder="请输入手机号"
          :rules="phoneRules"
          class="field"
        >
          <template v-slot:label>
            <div class="label">手机号</div>
          </template>
        </van-field>

        <van-field class="field">
          <template v-slot:label>
            <div class="label">状态</div>
          </template>
          <template #extra>
            <div class="status">已签约</div>
          </template>
        </van-field>
      </van-form>
    </div>
    <div style="display: flex; justify-content: center">
      <van-button
        v-if="isAuth"
        class="button"
        type="primary"
        native-type="submit"
        @click="isShowAuthDialog = true"
      >
        授权验证
      </van-button>
    </div>
    <!-- 确认弹窗 -->
    <CustomDialog
      name="提示"
      :show-cancel-btn="true"
      :show-confirm-btn="true"
      :visible="show"
      width="350"
      @confirm="onConfirm"
      @cancel="onCancel"
    >
      <template #content>
        <div class="dialog-content">
          解除后无法使用免密支付功能；确认解除免密签约吗？
        </div>
      </template>
    </CustomDialog>

    <!-- 确认授权弹窗 -->
    <CustomDialog
      name="授权验证"
      :show-cancel-btn="true"
      :show-confirm-btn="true"
      :visible="isShowAuthDialog"
      width="350"
      @confirm="onConfirmAuth"
      @cancel="onCancelAuth"
    >
      <template #content>
        <div class="auth-dialog-content">
          <div>
            确认签约
            <span style="font-weight: 700">{{ form.dptName }}</span>
            的
            <span style="font-weight: 700">
              {{ form.userName }}
              免密支付功能，签约成功食堂充值将直接付款，无支付验证环节。
            </span>
            <p>验证手机号：{{ form.phone }}</p>
          </div>

          <van-field
            v-model.trim="form.code"
            name="code"
            placeholder="请输入验证码"
            class="field"
          >
            <template #extra>
              <div
                class="message"
                :class="{ disabled: countdown > 0 }"
                @click="getVerificationCode"
              >
                {{ countdownText }}
              </div>
            </template>
          </van-field>
        </div>
      </template>
    </CustomDialog>
  </div>
</template>

<script>
import TopHeader from '@/components/topHeader/index.vue';
import { Toast } from 'vant';
import CustomDialog from '@/components/CustomDialog/index.vue';
import {
  getSignInfo,
  verCode,
  sign,
  terminateSign,
  signAuth
} from '@/api/free-password-sign/index';
import { getVerifyCode } from '@/api/person';

export default {
  name: 'SecretSign',
  components: { TopHeader, CustomDialog },
  data() {
    return {
      form: {
        cardNo: '',
        phone: '',
        code: '',
        signNo: ''
      },
      show: false,
      countdown: 0,
      timer: null,
      isSign: false,
      isAuth: false,
      // 表单校验规则
      bankCardRules: [
        { required: true, message: '请输入银行卡号', trigger: 'onBlur' },
        {
          validator: this.validateBankCard,
          message: '银行卡号格式不正确',
          trigger: 'onBlur'
        }
      ],
      phoneRules: [
        { required: true, message: '请输入手机号', trigger: 'onBlur' },
        {
          pattern: /^1[3-9]\d{9}$/,
          message: '请输入正确的手机号',
          trigger: 'onBlur'
        }
      ],
      codeRules: [
        { required: true, message: '请输入验证码', trigger: 'onBlur' },
        {
          pattern: /^\d{4,6}$/,
          message: '验证码格式不正确',
          trigger: 'onBlur'
        }
      ],
      isShowAuthDialog: false
    };
  },
  computed: {
    countdownText() {
      if (this.countdown > 0) {
        return `${this.countdown}秒后重新获取`;
      }
      return '获取验证码';
    }
  },
  async created() {
    await this.getInfo();
  },
  beforeDestroy() {
    // 组件销毁前清除定时器
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
  methods: {
    async onConfirmAuth() {
      if (!this.form.code) {
        Toast.fail('请输入验证码');
        return;
      }
      try {
        const res = await signAuth({
          code: this.form.code,
          id: this.form.id
        });
        if (res.code === 0) {
          Toast.success('签约成功！');

          await this.getInfo();
        }
      } catch (err) {
        console.log(err);
      } finally {
        if (this.timer) {
          clearInterval(this.timer);
        }
        this.isShowAuthDialog = false;
      }
    },
    onCancelAuth() {
      this.isShowAuthDialog = false;
    },

    async getInfo() {
      try {
        const res = await getSignInfo();
        const user = JSON.parse(sessionStorage.getItem('personInfo'));

        if (res.data.length === 0) {
          this.isSign = false;
          this.isAuth = false;
          this.$set(this, 'form', {});
          this.$set(this.form, 'userName', user.name);
          this.$set(this.form, 'dptName', user.organization.zhName);
        } else if (res.data[0].status === 1 && res.data[0].channel === 1) {
          this.isAuth = true;
          this.isSign = false;
          this.form.dptName = user.organization.zhName;
          this.form.cardNo = res.data[0].cardNo;
          this.form.phone = res.data[0].phone;
          this.form.signNo = res.data[0].signNo;
          this.form.userName = user.name;
          this.form.code = '';
          this.form.id = res.data[0].id;
        } else {
          this.isSign = true;
          this.isAuth = false;
          this.form.cardNo = res.data[0].cardNo;
          this.form.phone = res.data[0].phone;
          this.form.signNo = res.data[0].signNo;
          this.form.userName = user.name;
          this.form.dptName = user.organization.zhName;
          this.form.id = res.data[0].id;
        }
      } catch (err) {
        console.log(err);
      } finally {
      }
    },

    async onConfirm() {
      try {
        const res = await terminateSign(this.form.id);
        if (res.code === 0) {
          Toast.success('解约成功!');
          await this.getInfo();
        }
      } catch (err) {
        console.log(err);
      } finally {
        this.show = false;
      }
    },
    onCancel() {
      this.show = false;
    },
    // 自定义银行卡号校验
    validateBankCard(value) {
      if (!value) return false;

      // 移除空格，只允许数字
      const cleanedValue = value.replace(/\s/g, '');

      // 验证是否为纯数字且长度在16-19位之间（根据银行卡号标准）
      const isNumeric = /^\d+$/.test(cleanedValue);
      const isValidLength =
        cleanedValue.length >= 16 && cleanedValue.length <= 19;

      return isNumeric && isValidLength;
    },

    // 获取验证码
    async getVerificationCode() {
      // 如果正在倒计时，不能点击
      if (this.countdown > 0) {
        return;
      }

      // 验证手机号是否已填写且格式正确
      if (!this.form.phone) {
        Toast('请输入手机号');
        return;
      }
      if (!this.form.cardNo) {
        Toast('请输入银行卡号');
        return;
      }
      const phonePattern = /^1[3-9]\d{9}$/;
      if (!phonePattern.test(this.form.phone)) {
        Toast('请输入正确的手机号');
        return;
      }

      try {
        // 显示加载状态
        Toast.loading({
          message: '发送中...',
          forbidClick: true,
          duration: 0
        });

        // 调用后端接口发送验证码
        const response = !this.isAuth
          ? await verCode({
              organizationId: JSON.parse(sessionStorage.getItem('personInfo'))
                .organizationId,
              userId: this.$store.getters.userId,
              cardNo: this.form.cardNo,
              phone: this.form.phone
            })
          : await getVerifyCode({
              phone: this.form.phone,
              appKey: 'ZHONGHEZHIHUI123!@#'
            });

        Toast.clear();

        if (response.code === 0) {
          Toast.success('验证码发送成功');
          if (!this.isAuth) {
            this.form.signNo = response.data.signNo;
          }
          // 开始倒计时
          this.startCountdown();
        } else {
          Toast.fail(response.message || '验证码发送失败');
        }
      } catch (error) {
        Toast.clear();
        Toast.fail('网络错误，请稍后重试');
        console.error('获取验证码失败:', error);
      }
    },

    // 开始倒计时
    startCountdown() {
      this.countdown = 60;

      this.timer = setInterval(() => {
        this.countdown--;

        if (this.countdown <= 0) {
          clearInterval(this.timer);
          this.timer = null;
        }
      }, 1000);
    },

    // 表单提交
    async onSubmit() {
      if (this.isSign) {
        this.show = true;
      } else {
        await this.$refs.formRef
          .validate()
          .then(async () => {
            try {
              // 显示加载状态
              Toast.loading({
                message: '验证中...',
                forbidClick: true,
                duration: 0
              });

              // 调用后端接口验证信息
              const response = await sign({
                cardNo: this.form.cardNo,
                phone: this.form.phone,
                code: this.form.code,
                signNo: this.form.signNo,
                userId: this.$store.getters.userId,
                organizationId: JSON.parse(sessionStorage.getItem('personInfo'))
                  .organizationId
              });

              Toast.clear();

              if (response.code === 0) {
                Toast.success('签约成功');
                this.show = false;
                if (this.timer) {
                  clearInterval(this.timer);
                }
                await this.getInfo();
                // 这里可以跳转到下一步或执行其他操作
                // this.$router.push('/next-step');
              } else {
                Toast.fail(response.message || '验证失败');
              }
            } catch (error) {
              Toast.clear();
              Toast.fail('网络错误，请稍后重试');
              console.error('验证信息失败:', error);
            }
          })
          .catch(() => {});
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.container {
  min-height: 100vh;
  background-color: #f5f5f5;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 45px;
}
.tips {
  width: 343px;
  height: 172px;
  border-radius: 10px;
  opacity: 1;
  background: #e5e5e5;
  padding: 16px;
  margin-top: 40px;
  color: #333333;
  font-size: 16px;
  font-weight: 500;
  font-family: 'PingFang SC';
  text-align: left;
  line-height: 24px;
  box-sizing: border-box;
}
.content {
  margin: 0 16px;
  margin-top: 15px;
  background-color: #fff;
  border-radius: 10px;
  width: 343px;
  padding: 20px;
  box-sizing: border-box;
  position: relative;

  .mask {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    background: #0000004d;
    z-index: 999;
    border-radius: 10px;
    background-image: url('~@/assets/images/auth-mask.png');
    background-size: 90px 90px;
    background-position: top right;
    background-repeat: no-repeat;
  }
  .field {
    height: 56px;
    padding: 20px 0 !important;
    display: flex;
    align-items: flex-start;

    .label {
      color: #333333;
      font-size: 16px;
      font-weight: 500;
      font-family: 'PingFang SC';
      width: 64px;
      line-height: 16px;
      flex-shrink: 0;
    }

    .message {
      color: #fa5050;
      font-size: 16px;
      font-weight: 700;
      font-family: 'PingFang SC';
      cursor: pointer;
      height: 16px;
      line-height: 16px;
      &.disabled {
        cursor: not-allowed;
      }
    }
  }
}
.button {
  width: 343px;
  height: 44px;
  border-radius: 25px;
  opacity: 1;
  background: #fa5050;
  box-shadow: 0 0 20px 0 #fa505040;
  color: #ffffff;
  font-size: 16px;
  font-weight: 700;
  font-family: 'PingFang SC';
  margin-top: 54px;
  border: none;

  &:active {
    opacity: 0.9;
  }
}
::v-deep .van-field__value {
  line-height: 16px;
  font-size: 16px;
  font-weight: 700;
  font-family: 'PingFang SC';
  width: 100%;
}

::v-deep .van-cell {
  padding: 0;
}

::v-deep .van-cell::after {
  display: none;
}

::v-deep .van-field__control {
  color: #333;
  font-size: 16px;
}

::v-deep .van-field__error-message {
  font-size: 12px;
  color: #fa5050;
}

::v-deep .van-field--error .van-field__control {
  color: #fa5050;
}

::v-deep .van-field__control {
  line-height: 16px;
  height: 16px;
}
.auth-dialog-content,
.dialog-content {
  margin-top: 14px;
  color: #666666;
  font-size: 16px;
  font-weight: 500;
  font-family: 'PingFang SC';
  text-align: center;
  line-height: 16px;
  margin-bottom: 30px;
  .field {
    height: 56px;
    padding: 20px !important;
    display: flex;
    align-items: flex-start;
    width: 255px;

    .message {
      color: #fa5050;
      font-size: 16px;
      font-weight: 700;
      font-family: 'PingFang SC';
      cursor: pointer;
      height: 16px;
      line-height: 16px;
      &.disabled {
        cursor: not-allowed;
      }
    }
  }
}

.auth-dialog-content {
  line-height: 24px;
  .field {
    height: 56px;
    border-radius: 10px;
    margin-top: 20px;
    background-color: #f7f7f7;
  }
}

::v-deep .van-field--disabled {
  .van-field__control {
    color: #333333 !important;
    -webkit-text-fill-color: #333333;
    font-size: 16px;
    font-weight: 700;
    font-family: 'PingFang SC';
    text-align: right;
  }
}
.status {
  width: 60px;
  height: 22px;
  border-radius: 36.5px;
  opacity: 1;
  background: #eafaf1;
  color: #25b32f;
  font-size: 12px;
  font-weight: 500;
  font-family: 'PingFang SC';
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
